import { OnboardingStep as ApiOnboardingStep } from "@/api/__generated__/schemas";
import { MessageKey } from "@/i18n";
import { InputIcon } from "@/ui";

export const OnboardingStepValues = [
  ApiOnboardingStep.CREATE_ORGANIZATION,
  ApiOnboardingStep.SETUP_PLATFORM,
  ApiOnboardingStep.CREATE_CIRCUIT,
  ApiOnboardingStep.ADD_OPERATOR,
  ApiOnboardingStep.CREATE_EVENT,
] as const;

export type OnboardingStep = (typeof OnboardingStepValues)[number];

export type OnboardingStepStatus = {
  stepType: OnboardingStep;
  isCompleted: boolean;
};

export type Onboarding = {
  steps: OnboardingStepStatus[];
};

/**
 * Scope-agnostic view model for a single onboarding step. Both the league and
 * platform/federation surfaces build this from their own step metadata +
 * completion state, so the shared presentational components (`OnboardingCard`,
 * `OnboardingStepsGrid`) never depend on either scope's domain types. `href` is
 * already resolved/scoped by the container before it reaches the components.
 */
export type OnboardingStepView = {
  id: string;
  title: MessageKey;
  description: MessageKey;
  icon: InputIcon;
  href?: string;
  isExternal?: boolean;
  isCompleted: boolean;
};
